import { I } from './Icons'

/** Dollar pad for prices and the drawer count. Whole dollars, up to 7 digits. */
export function NumPad({ value, onChange, max = 7, decimal = false }: { value: string; onChange: (v: string) => void; max?: number; decimal?: boolean }) {
  const press = (k: string) => {
    if (k === 'CLEAR') return onChange('')
    if (k === 'DEL') return onChange(value.slice(0, -1))
    if (value === '' && k === '0' && !decimal) return
    if (k === '.' && (value.includes('.') || value === '')) return
    onChange((value + k).slice(0, max))
  }
  return (
    <div className="pad pad--money">
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((k) => <button key={k} type="button" className="pad__key" onClick={() => press(k)}>{k}</button>)}
      <button type="button" className="pad__key ghost" onClick={() => press(decimal ? '.' : 'CLEAR')}>{decimal ? '.' : 'Clear'}</button>
      <button type="button" className="pad__key" onClick={() => press('0')}>0</button>
      <button type="button" className="pad__key ghost" aria-label="Delete" onClick={() => press('DEL')}>{I.del()}</button>
    </div>
  )
}
